/* ============================================
   HAEZEL TECH | Collection layout v1.0
   - Section dividers between iPhone, Samsung,
     laptop sleeves and AirPods in identity collections
   - Quick-jump device tabs (rendered by the collection header)
   - Only in the default order with no filters applied
============================================ */
(function() {
  'use strict';

  var CFG = window.hzLayout || {};
  if (!CFG.enabled) return;

  var SECTIONS = {
    iphone:  { eyebrow: 'Phone cases',       title: 'iPhone cases',         sub: 'iPhone 14 to 18 Pro Max' },
    samsung: { eyebrow: 'Phone cases',       title: 'Samsung Galaxy cases', sub: 'Galaxy S20 to S26' },
    sleeve:  { eyebrow: 'Complete the set',  title: 'Laptop sleeves',       sub: '13″ and 15″ · Same designs as the cases' },
    airpods: { eyebrow: 'Complete the set',  title: 'AirPods cases',        sub: 'AirPods and AirPods Pro' }
  };

  function isDefaultView() {
    var p = new URLSearchParams(window.location.search);
    var plain = true;
    p.forEach(function(v, k) {
      if (k.indexOf('filter.') === 0) plain = false;
      if (k === 'q') plain = false;
      if (k === 'sort_by' && v && v !== 'manual') plain = false;
    });
    return plain;
  }

  function kindOf(li) {
    var h = li.querySelector('.card__heading');
    var t = (h ? h.textContent : li.textContent || '').toLowerCase();
    if (t.indexOf('laptop sleeve') !== -1) return 'sleeve';
    if (t.indexOf('airpods') !== -1) return 'airpods';
    if (t.indexOf('samsung') !== -1 || t.indexOf('galaxy') !== -1) return 'samsung';
    return 'iphone';
  }

  function makeDivider(kind) {
    var s = SECTIONS[kind];
    var li = document.createElement('li');
    li.className = 'hz-divider';
    li.id = 'hz-sec-' + kind;
    li.setAttribute('data-hz-kind', kind);
    li.innerHTML =
      '<p class="hz-divider__eyebrow">' + s.eyebrow + '</p>' +
      '<h2 class="hz-divider__title">' + s.title + '</h2>' +
      (s.sub ? '<p class="hz-divider__sub">' + s.sub + '</p>' : '');
    return li;
  }

  function apply() {
    var grid = document.getElementById('product-grid');
    var tabs = document.querySelector('.hz-tabs');
    var plain = isDefaultView();

    if (tabs) tabs.hidden = !plain;
    if (!grid || grid.tagName !== 'UL') return;

    grid.querySelectorAll(':scope > .hz-divider').forEach(function(d) { d.remove(); });
    if (!plain) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    if (!items.length) return;

    var kinds = items.map(kindOf);
    var distinct = kinds.filter(function(k, i) { return kinds.indexOf(k) === i; });
    // One device type on this page: only label it if the collection mixes devices
    if (distinct.length < 2 && !CFG.mixed) return;

    var last = null;
    items.forEach(function(li, i) {
      if (kinds[i] !== last) {
        grid.insertBefore(makeDivider(kinds[i]), li);
        last = kinds[i];
      }
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function() { queued = false; apply(); }, 50);
  }

  // Re-apply after Shopify swaps the grid (filters, sort, back button)
  new MutationObserver(function(muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1 || (n.classList && n.classList.contains('hz-divider'))) continue;
        if (n.id === 'product-grid' || n.id === 'ProductGridContainer' ||
            (n.querySelector && n.querySelector('#product-grid')) ||
            (n.classList && n.classList.contains('grid__item'))) {
          queue();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  var lastUrl = window.location.href;
  setInterval(function() {
    if (window.location.href !== lastUrl) { lastUrl = window.location.href; queue(); }
  }, 300);

  // Tabs: smooth scroll when the section is on this page, otherwise follow the link
  document.addEventListener('click', function(e) {
    var a = e.target.closest && e.target.closest('.hz-tab');
    if (!a) return;
    var target = a.getAttribute('data-hz-target');
    var page = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    if (String(page) !== a.getAttribute('data-hz-page')) return;
    var el = target && document.getElementById(target);
    if (!el) return;
    e.preventDefault();
    var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });
    document.querySelectorAll('.hz-tab').forEach(function(t) { t.classList.toggle('is-active', t === a); });
  });

  function init() {
    apply();
    // Arrived from a tab on another page (e.g. ?page=2#hz-sec-sleeve)
    var hash = window.location.hash.replace('#', '');
    if (hash.indexOf('hz-sec-') === 0) {
      setTimeout(function() {
        var el = document.getElementById(hash);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 90 });
        document.querySelectorAll('.hz-tab').forEach(function(t) {
          t.classList.toggle('is-active', t.getAttribute('data-hz-target') === hash);
        });
      }, 120);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
